import roller from 'common/module/ui/roller';

import applicationBootstrap from 'website/bootstrap';
import { socialActionsBootstrap } from 'website/bootstrap/socialActionsBootstrap';
import titleRating from 'website/containers/entity/titleRating';
import userOpinion from 'website/containers/user-action/UserOpinionBannerEntry';
import userAddToCollection from 'website/containers/user-action/userAddToCollection';
import userReviewLink from 'website/containers/user-action/userReviewLink';
import userSeenIt from 'website/containers/user-action/userSeenIt';
import affinityBadge from 'website/containers/user/affinityBadge';
import affinitySuggestions from 'website/containers/user/affinitySuggestions';
import reviewsSocial from 'website/containers/user/reviewsSocial';
import userFriendsRating from 'website/containers/user/userFriendsRating';
import loadOutbrain from 'website/module/advertisement/outbrain';
import loadTaboola from 'website/module/advertisement/taboola';
// import player
import initPlayer from 'website/module/player';
import initPlayerExport from 'website/module/player/export';
import asyncGallery from 'website/module/ui/async-gallery';
import dropdownLinks from 'website/module/ui/dropdown-custom';
import facebookWidgets from 'website/module/ui/facebookWidgets';
// import share
import initMoreTriggerOverlay from 'website/module/ui/more-trigger-overlay';
import thirdNav from 'website/module/ui/third-nav';

// bootstrap the application / store
applicationBootstrap().then(() => {
  initMoreTriggerOverlay();
  initPlayer();
  initPlayerExport();

  thirdNav();

  asyncGallery();

  roller();

  dropdownLinks();

  reviewsSocial();

  titleRating();

  facebookWidgets();

  loadOutbrain();

  loadTaboola();

  // Social user Action
  userOpinion();
  userReviewLink();
  userSeenIt();
  userFriendsRating();
  userAddToCollection();
  socialActionsBootstrap().then(() => {
    // to avoid having a display skip.
    // the macaron is loaded after the social request
    affinityBadge();
  });
  affinitySuggestions();
});
